// Compartido por API y cliente. Los días de franjas nocturnas pertenecen al inicio.
const formatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
const weekdays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
function activeLevel(levels, date = new Date()) {
  const parts = Object.fromEntries(formatter.formatToParts(date).map(p => [p.type,p.value]));
  const day = weekdays.indexOf(parts.weekday), minute = Number(parts.hour)*60+Number(parts.minute);
  const minutes = value => Number(value.slice(0,2))*60+Number(value.slice(3));
  return (levels || []).find(level => {
    if (!level.enabled) return false;
    const start = minutes(level.start), end = minutes(level.end);
    if(start === end) return level.days.includes(day);
    if(start < end) return level.days.includes(day) && minute >= start && minute < end;
    return (level.days.includes(day) && minute >= start) || (level.days.includes((day+6)%7) && minute < end);
  });
}
function effectivePrice(product, levels, date) {
  const level = activeLevel(levels,date);
  const price = level && (product.prices || []).find(p => p.levelId === level.id);
  return price ? price.price : product.price;
}
module.exports = { activeLevel, effectivePrice };
